/**
 * Handle Language switcher
 *
 * When we use the language switcher in the header on an other page then the homepage, for example a PDP or collection page,
 * the submit button should be redirected to that counterpart of the linked store.
 * We use the rendered alternate links from the Multi Store Hreflang Tags app to find the right counter part.
 */

// get language switcher and its dropdown options
const languageSwitcher = document.querySelectorAll('[data-language-switcher]');
const languageSwitcherOptions = document.querySelectorAll('[data-language-switcher-link]');

// listen for click on dropdown option
languageSwitcherOptions.forEach(option => {
  option.addEventListener('click', (e) => {
    e.preventDefault();

    if (!e.currentTarget.href) return false;

    // check if we have a counterPartUrl otherwise fallback to the original href (=homepage)
    let urlToOpen = e.currentTarget.href;
    const newUrl = urlToOpen ? getCounterPartUrl(removeProtocol(urlToOpen)) : false;
    if (newUrl) urlToOpen = newUrl;

    // add current url attributes
    urlToOpen = urlToOpen + location.search;

    // open link
    window.location.href = urlToOpen;

  });
});

/**
 * removeProtocol
 * @description Remove http or https from url
 */
function removeProtocol(url) {

  const domain = (new URL(url));
  if (!domain.host) return false;

  const firstUrlPath = domain.pathname.split('/')[1];

  // return the url with the language code if there's a language (2 digits) in the url, otherwise return the domain host only
  return firstUrlPath.length == 2 ? `${domain.host}/${firstUrlPath}` : domain.host;

}

/**
 * getCounterPartUrl
 * @description Find the right counter part by using the alternate links that the app Multi Store Hreflang renders.
 */
function getCounterPartUrl(url) {

  // Find the store to link to. Store item contains the primary domain and myshopify domain.
  // The reason why we need to find the domain and shopify domain is because  Multi Store Hreflang sometimes outputs the primary domain and sometimes the myshopify domain.
  const stores = languageSwitcher[0].dataset.stores || false;
  const storesArray = stores?.split(',');
  if (storesArray.length === 0) return false;

  let storeToLinkTo = null;
  storesArray.forEach(function(store){
    let storeArr = store.split('|');

    const storeUrlMatch = storeArr.find(storeUrl => storeUrl == url);
    if (storeUrlMatch) {
      storeToLinkTo = storeUrlMatch;
    }

  });

  // get counterPartLink
  const alternateLinksArray = [...document.querySelectorAll('link[rel="alternate"]')];
  if (alternateLinksArray.length === 0) return false;

  // get matching link and return value
  const alternateLinkHrefs = alternateLinksArray
    .filter(link => link.hasAttribute('hreflang'))
    .map(link => link.href);
  const counterPartLink = alternateLinkHrefs?.find(href => href.indexOf(`https://${storeToLinkTo}`) > -1) || null;

  return counterPartLink || false;
}